import LeftImage from './components/LeftImage/LeftImage';
import InfoCard from '../../InfoCard';
import styles from './authFormContainer.module.scss';

export default function AuthFormContainer({
  children,
  errorMessage,
  onDismissError
}: {
  children: React.ReactNode;
  errorMessage?: string;
  onDismissError?: () => void;
}) {
  return (
    <div className={styles.wrapper}>
      {errorMessage && (
        <InfoCard
          dismissable
          className={styles.notification}
          severity="error"
          onDismiss={onDismissError}
        >
          {errorMessage}
        </InfoCard>
      )}
      <div className={styles.authFormContainer}>
        <div className={styles.left}>
          <LeftImage />
        </div>
        <div className={styles.right}>{children}</div>
      </div>
    </div>
  );
}
